import { createAction } from 'redux-actions';

export const GET_ARTICLES = 'GET_ARTICLES';
export const GET_ARTICLES_SUCCESS = 'GET_ARTICLES_SUCCESS';
export const GET_ARTICLES_ERROR = 'GET_ARTICLES_ERROR';
export const GET_ARTICLE = 'GET_ARTICLE';
export const GET_ARTICLE_SUCCESS = 'GET_ARTICLE_SUCCESS';
export const GET_ARTICLE_ERROR = 'GET_ARTICLE_ERROR';

export const loadArticles = createAction(GET_ARTICLES, (sectionId, page) => {
    return {
        sectionId,
        page
    }
});
export const loadArticle = createAction(GET_ARTICLE, id => id);